import React from "react";
import { motion } from "framer-motion";
import { IoClose } from "react-icons/io5";

const FeaturesModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <motion.div 
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        className="bg-white rounded-2xl shadow-xl p-6 max-w-sm w-full text-center"
      >
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-500 hover:text-gray-700">
          <IoClose size={24} />
        </button>
        <h2 className="text-xl font-semibold text-gray-800">Upgrade Needed</h2>
        <p className="text-gray-600 mt-2">Upgrade your plan to use this</p>
        <button
          onClick={onClose}
          className="mt-4 btn-primary px-5 py-2 rounded-lg hover:bg-opacity-90 transition"
        >
          Okay
        </button>
      </motion.div>
    </div>
  );
};

export default FeaturesModal;
